/// <amd-module name="Build/PipelinesLanguage/Constants" />

// use languageId "yaml" to piggyback on monaco "yaml" syntax highlight 
export const pipelinesLanguageId = "yaml";
export const pipelinesModelUri = "ms.vss-build-web/pipelines-language/Content/azure-pipelines-schema.json";

export const languageExtentionPoint: monaco.languages.ILanguageExtensionPoint = {
    id: pipelinesLanguageId,
    extensions: ['.yaml', '.yml'],
    aliases: [ 'azure-pipelines', 'YAML', 'yaml', "yml"],
    mimetypes: ["application/x-yaml"],
};

export const TelemetryArea: string = "Pipelines";
export const TelemetryFeature: string = "YAML editor";
